import { Separator, Stack, StackItem } from "@fluentui/react";
import React, { useContext, useState } from "react";
import {
  stackTokensWithGap20,
  stackTokensWithGap30,
} from "../../QuotationStyle";
import { QuotationContext } from "../../QuotationContext";
import { QuotationInfoType } from "../../Quotation.types";
import { stackStyles } from "./BundleSelectionStyle";

export const BundleSelection = () => {
  const { quotationInfo } = useContext(QuotationContext) as QuotationInfoType;
  const renderBundleItems = () => {
    const { skuData } = quotationInfo;
    if (skuData?.bundles?.length) {
      return skuData?.bundles?.map((item: any, index: number) => {
        return (
          <Stack
            verticalFill
            verticalAlign="center"
            tokens={stackTokensWithGap30}
            styles={stackStyles}
            key={index}
          >
            <p>{item.bundleTitle}</p>
          </Stack>
        );
      });
    }
  };
  return (
    <Stack
      horizontal
      horizontalAlign="start"
      style={{ marginLeft: 200, marginRight: 200 }}
    >
      <Stack horizontal horizontalAlign="start" tokens={stackTokensWithGap20}>
        <Separator vertical />
        <Stack verticalFill verticalAlign="start">
          <StackItem>
            <h4>Select Bundle</h4>
          </StackItem>
          <StackItem>
            <Stack
              horizontal
              horizontalAlign="start"
              tokens={stackTokensWithGap30}
            >
              {renderBundleItems()}
            </Stack>
          </StackItem>
        </Stack>
      </Stack>
      <Stack horizontal horizontalAlign="start" tokens={stackTokensWithGap20}>
        <Separator vertical />
        <StackItem>
          <h4>Non-Bundle</h4>
        </StackItem>
      </Stack>
    </Stack>
  );
};
